export default __webpack_public_path__ + "static/media/new-cover.0fc0560a.png";